import React, { useState, useEffect, useRef } from 'react';
import Dialog from '@material-ui/core/Dialog';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';

export const TOUR_IMAGE_EVENT = 'tour:images';

export function showTourImages(slides, onDone) {
  window.dispatchEvent(new CustomEvent(TOUR_IMAGE_EVENT, { detail: { slides, onDone } }));
}

export default function TourImageDialog() {
  const [open, setOpen] = useState(false);
  const [slides, setSlides] = useState([]);
  const [index, setIndex] = useState(0);
  const onDoneRef = useRef(null);

  useEffect(() => {
    function handler(e) {
      onDoneRef.current = e.detail.onDone;
      setSlides(e.detail.slides);
      setIndex(0);
      setOpen(true);
    }
    window.addEventListener(TOUR_IMAGE_EVENT, handler);
    return () => window.removeEventListener(TOUR_IMAGE_EVENT, handler);
  }, []);

  function handleDone() {
    setOpen(false);
    if (onDoneRef.current) onDoneRef.current();
  }

  const slide = slides[index];

  return (
    <Dialog
      open={open}
      fullWidth
      PaperProps={{
        style: {
          maxWidth: '90vw',
          maxHeight: '92vh',
          margin: 'auto',
          borderRadius: 10,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        },
      }}
    >
      {/* Header — matches Driver.js popover style */}
      <div
        style={{
          backgroundColor: '#142E3E',
          padding: '14px 48px 14px 16px',
          position: 'relative',
          flexShrink: 0,
        }}
      >
        <Typography style={{ color: '#fff', fontWeight: 700, fontSize: 15, lineHeight: 1.35 }}>
          {slide ? slide.title : ''}
        </Typography>
        <Typography style={{ color: 'rgba(255,255,255,0.65)', fontSize: 12, marginTop: 2 }}>
          {index + 1} of {slides.length}
        </Typography>
        <IconButton
          size="small"
          onClick={handleDone}
          style={{ position: 'absolute', top: 10, right: 10, color: 'rgba(255,255,255,0.8)' }}
        >
          <CloseIcon fontSize="small" />
        </IconButton>
      </div>

      {/* Description — same look as Driver.js description panel */}
      {slide && slide.desc && (
        <div
          style={{
            padding: '14px 16px',
            borderBottom: '1px solid #e8e8e8',
            background: '#fff',
            flexShrink: 0,
          }}
        >
          <Typography style={{ fontSize: 14, lineHeight: 1.65, color: '#333' }}>
            {slide.desc}
          </Typography>
        </div>
      )}

      {/* Screenshot or mock component */}
      <div style={{ flex: 1, overflow: 'auto', background: '#f5f5f5' }}>
        {slide && (
          slide.component
            ? React.createElement(slide.component)
            : (
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: 200 }}>
                <img
                  src={slide.img}
                  alt={slide.title}
                  style={{ maxWidth: '100%', maxHeight: 'calc(92vh - 200px)', objectFit: 'contain', display: 'block' }}
                />
              </div>
            )
        )}
      </div>

      {/* Navigation footer */}
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          padding: '10px 16px',
          borderTop: '1px solid #e8e8e8',
          background: '#fff',
          flexShrink: 0,
        }}
      >
        <Button disabled={index === 0} onClick={() => setIndex((i) => i - 1)}>
          ← Previous
        </Button>
        {index < slides.length - 1 ? (
          <Button
            variant="contained"
            style={{ backgroundColor: '#142E3E', color: '#fff' }}
            onClick={() => setIndex((i) => i + 1)}
          >
            Next →
          </Button>
        ) : (
          <Button
            variant="contained"
            style={{ backgroundColor: '#142E3E', color: '#fff' }}
            onClick={handleDone}
          >
            Continue Tour →
          </Button>
        )}
      </div>
    </Dialog>
  );
}
